var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFl30(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.47,15.23c0,1.09-.28,2.12-.76,3.02l1.08,1.08c.73-1.2,1.16-2.6,1.16-4.1,0-1.62-.49-3.13-1.33-4.39l-1.08,1.08c.58.97.92,2.1.92,3.31Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.53,15.23c0-1.21.34-2.34.92-3.32l-1.08-1.08c-.84,1.26-1.33,2.77-1.33,4.39,0,1.5.43,2.9,1.16,4.1l1.08-1.08c-.48-.9-.76-1.93-.76-3.02Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m18.31,20.77c-.13.08-.25.16-.39.23-.88.45-1.87.7-2.92.7s-2.04-.26-2.92-.7c-.13-.07-.26-.15-.39-.23l-1.21,1.21v3.86c0,.89.6,1.64,1.41,1.88v.81c0,.69.56,1.26,1.26,1.26h3.7c.69,0,1.26-.56,1.26-1.26v-.81c.81-.24,1.41-.99,1.41-1.88v-3.86l-1.21-1.21Zm-1.68,7.53h-3.26v-.49h3.26v.49Zm1.41-2.46c0,.27-.22.49-.49.49h-5.1c-.27,0-.49-.22-.49-.49v-3.26c.94.39,1.96.61,3.04.61s2.1-.22,3.04-.61v3.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m11.98,9.52c.9-.48,1.93-.75,3.02-.75s2.12.27,3.02.75l1.08-1.08c-1.2-.73-2.6-1.16-4.11-1.16s-2.9.43-4.1,1.15l1.08,1.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m29.65,28.61l-13.61-13.61L29.65,1.39c.35-.23.45-.69.23-1.05-.23-.35-.69-.45-1.05-.23l-13.84,13.84L1.16.12C.81-.11.35,0,.12.35-.11.7,0,1.17.35,1.39l13.61,13.61L.35,28.61c-.35.23-.45.69-.23,1.05.14.23.39.35.64.35.14,0,.28-.04.41-.12l13.84-13.84,13.84,13.84c.13.08.27.12.41.12.25,0,.49-.12.64-.35.23-.35.12-.82-.23-1.05Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFl30);
export default __webpack_public_path__ + "static/media/FL30.3d67fba0e3ee491b53e022aeeaf4e729.svg";
export { ForwardRef as ReactComponent };